// Define Variables for all different colours in the library
export default {
  logoOrange: '#fa9100',
  orange: '#e3710a',
  orange50: '#f1b885',
  orange25: '#f8dcc2',
  orange10: '#fcf1e7',
  blueGrey: '#3c4a60',
  blueGrey75: '#6d7788',
  blueGrey50: '#9ea5b0',
  blueGrey25: '#ced2d7',
  blueGrey10: '#ecedef',
  darkGrey: '#1c2026',
  darkGrey75: '#55585c',
  darkGrey50: '#8e9093',
  darkGrey25: '#c6c7c9',
  darkGrey10: '#e8e9e9',
  red: '#cc3333',
  SubGrey: '#292f39',
  brown: '#9d5b00',
  teal: '#208179',
  teal50: '#90c0bc',
  teal15: '#deeceb',
  blue: '#1e76a5',
  blue50: '#8fbbd2',
  blue15: '#ddeaf2',
  green: '#27871d',
  green50: '#93c38e',
  green15: '#dfeddd',
  yellow: '#f5e34a',
  yellow50: '#faf1a5',
  yellow15: '#fefbe4',
  white: '#ffffff'
};
